<div class="chat-head">
  <div class="chat-head-wrapper-info">
    <div class="chat-head__info">
      <div class="arrow" (click)="back()"><ui-icon nameIcon="arrow_back"></ui-icon></div>
      <div class="info-user">
        <div class="user">
          <div class="image" [style.background-color]="(title | firstLetters | avatarColor)"><span>{{title | firstLetters}}</span></div>
          <div class="title">{{title}}</div>
        </div>
      </div>
    </div>
    <div class="chat-head__action">
      <div class="action-box" (click)="call()">
        <ui-icon [nameIcon]="'local_phone'"></ui-icon>
        <span class="action-box__title">Начать звонок</span>
      </div>
      <ui-icon [nameIcon]="'more_vert'"  nz-dropdown [nzDropdownMenu]="menu2" nzPlacement="bottomRight"></ui-icon>
    </div>
  </div>
  <div class="chat-head-wrapper-call" *ngIf="false"><!--isCallActive-->
    <span class="caption">Вы можете ответить на звонок</span>
    <ui-button (click)=call()>Ответить</ui-button>
  </div>
</div>

<nz-dropdown-menu #menu2="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="deleteChat()"><div class="text-inner-icon"><ui-icon nameIcon="delete"></ui-icon>Удалить чат</div></li>
  </ul>
</nz-dropdown-menu>
